import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import Input from 'components/common/Input';
import { useForm } from 'react-hook-form';
import { currency, noCurrency } from 'helpers/utils';
import IconButton from 'components/common/IconButton';

const FormTerrain = ({ data, setData, product, setProduct, onClose }) => {
 const [options, setOptions] = useState(data.map(e => ({ value: e.name, label: e.name })));
 const {
  reset,
  register,
  setValue,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues: { plus: false } });

 useEffect(() => {
  if (product?.data)
   Object.entries(product?.data).map(d => {
    setValue(d[0], /mtr/.test(d[0]) ? currency(d[1], true) : d[1]);
   });
 }, [product]);

 useEffect(() => {
  setOptions(data.map(e => ({ value: e.name, label: e.name })));
 }, [data]);

 const onSubmitData = async newD => {
  const { plus, ...newData } = newD;

  const index = product?.currentIndex;
  newData.mtr = noCurrency(newData.mtr);
  newData.price = newData.mtr * newData.area;

  if (/\d/.test(index)) setData(old => old.map((row, i) => (i === index ? { ...newData } : row)));
  else setData(old => old.concat([newData]));

  if (product || !plus) {
   onClose();
   setProduct(null);
  }

  reset({
   blocks: null,
   stage: null,
   num: null,
   area: null,
   mtr: null,
   type: null,
   status: null,
   description: null,
   purlieu: null,
   price: null
  });
 };

 const onChange = ({ target: { name, value } }) => setValue(name, currency(value, true));

 const onError = e => {
  console.log(e, 'se genero un error en el formulario');
 };

 return (
  <>
   <Row className="mb-3 g-3">
    <Input
     type="text"
     errors={errors}
     label="Bloque"
     name="blocks"
     placeholder="Blq |MZ |Sector"
     formGroupProps={{ as: Col, sm: { span: 6, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('blocks', {
       //required: 'Debe especificar el alias del bloque',
       validate: value => !/[^A-Za-z0-9_-]/g.test(value) || 'El nombre debe tener caracteres validos',
       minLength: { value: 1, message: 'El nombre debe tener al menos 1 caracteres' }
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      maxLength: 50,
      size: 'sm'
     }}
    />

    <Input
     type="text"
     name="stage"
     label="Etapa"
     errors={errors}
     placeholder="Etapa"
     formGroupProps={{ as: Col, sm: { span: 6, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('stage', {
       required: true,
       validate: value => !/[^A-Za-z0-9_-]/g.test(value) || 'Existen caracteres invalidos',
       minLength: { value: 1, message: 'Al menos 1 caracter' }
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />
   </Row>

   <Row className="mb-3 g-3">
    <Input
     type="text"
     errors={errors}
     label="Lote"
     name="num"
     placeholder="Numero"
     formGroupProps={{ as: Col, sm: { span: 3, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('num', {
       required: 'Debe especificar el lote',
       validate: value => parseFloat(value) > 0 || 'Debe especificar el numero de producto'
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />

    <Input
     type="text"
     name="area"
     label="Area"
     errors={errors}
     placeholder="Mtr2"
     formGroupProps={{ as: Col, sm: { span: 3, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('area', {
       required: 'Debe especificar una area',
       validate: value => parseFloat(value) > 1 || 'El area debe ser mayor a 1 mtr2'
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />

    <Input
     name="mtr"
     type="text"
     errors={errors}
     label="ValorMtr2"
     placeholder="Valor"
     formGroupProps={{ as: Col, sm: { span: 6, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('mtr', {
       required: 'Debe especificar un valor para el mtr2',
       validate: value => /\$|^0/.test(value) || 'Debe especificar un valor valido'
      }),
      className: 'text-center',
      autoComplete: 'off',
      disabled: false,
      size: 'sm',
      onChange
     }}
    />
   </Row>

   <Row className="mb-3 g-3">
    <Input
     name="type"
     type="select"
     errors={errors}
     label="Financiacion"
     placeholder="Seleccione Financiacion"
     options={options}
     formGroupProps={{ as: Col, sm: { span: 6, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('type', { required: 'Debe seleccionar un tipo de financiamiento' }),
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />

    <Input
     type="select"
     name="status"
     label="Status"
     errors={errors}
     placeholder="Seleccione Estado"
     options={[
      { label: 'Available', value: 'Available' },
      { label: 'Inactive', value: 'Inactive' }
     ]}
     formGroupProps={{ as: Col, sm: { span: 6, offset: 0 } }}
     formLabelProps={{ className: 'mb-0 fs--1' }}
     formControlProps={{
      ...register('status', { required: 'Debe seleccionar un estado' }),
      autoComplete: 'off',
      disabled: false,
      size: 'sm'
     }}
    />
   </Row>

   <Input
    type="textarea"
    errors={errors}
    name="description"
    label="Descripcion"
    placeholder="Campo para descripcion (opcional)"
    formGroupProps={{ className: 'mb-3' }}
    formLabelProps={{ className: 'text-lg-end mb-1' }}
    formControlProps={{
     ...register('description', { setValueAs: v => (v ? v : null) }),
     autoComplete: 'off',
     disabled: false,
     size: 'sm',
     rows: 2
    }}
   />

   <Input
    name="purlieu"
    type="textarea"
    errors={errors}
    label="Linderos"
    placeholder="Campo para linderos (opcional valido para generar promesas)"
    formGroupProps={{ className: 'mb-3' }}
    formLabelProps={{ className: 'text-lg-end mb-1' }}
    formControlProps={{
     ...register('purlieu', { setValueAs: v => (v ? v : null) }),
     autoComplete: 'off',
     disabled: false,
     size: 'sm',
     rows: 3
    }}
   />

   {!product && (
    <Form.Check
     type="switch"
     id="custom-switch"
     label="Seguir agregando financiamientos?"
     className="form-label-nogutter py-3"
     name="plus"
     {...register('plus')}
    />
   )}

   <IconButton
    size="sm"
    transform="shrink-3"
    className="float-end"
    variant="falcon-default"
    icon={product ? 'redo-alt' : 'plus'}
    onClick={() => handleSubmit(onSubmitData, onError)()}
   >
    {product ? 'Actualizar' : 'Agregar'}
   </IconButton>

   <IconButton
    size="sm"
    type="reset"
    icon="ban"
    transform="shrink-3"
    variant="falcon-default"
    className=""
    onClick={() => setProduct(null)}
   >
    Descartar
   </IconButton>
  </>
 );
};

FormTerrain.propTypes = {
 data: PropTypes.array,
 setData: PropTypes.func,
 product: PropTypes.object,
 setProduct: PropTypes.func, //.isRequired,
 onClose: PropTypes.func
};

export default FormTerrain;
